module.exports = __webpack_public_path__ + "assets/img/14_1560_big.c305a197.jpg";